/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAccountmanagersList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_MANAGERS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getManagerDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_MANAGER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addManager: (data) => {
    return axios.post(API_ENDPOINTS.ADD_MANAGER, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  updateManager: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_MANAGAER_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteManager: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_MANAGER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  }
};
